import * as commonUtils from './common'
import * as authCenterUtils from './auth-center'

export default {
    ...commonUtils,
    ...authCenterUtils
}
